import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FUNNELS } from "@/lib/funnels";
import { ArrowRight } from "lucide-react";

export const PathCards = ({ exclude }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-5 md:grid-cols-3" data-testid="path-cards">
      {Object.entries(FUNNELS).filter(([k]) => k !== exclude).map(([k, cfg]) => {
        const Icon = cfg.icon;
        return (
          <Link key={k} to={cfg.path} className={`group relative overflow-hidden rounded-3xl bg-gradient-to-br ${cfg.tint} border border-white p-7 shadow-md transition-transform hover:-translate-y-1 hover:shadow-xl`} data-testid={`path-card-${k}`}>
            <span className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br ${cfg.accent} text-white shadow-lg`}><Icon className="h-6 w-6" /></span>
            <p className="mt-5 font-heading text-xl font-extrabold text-slate-900">{t(`funnel.paths.${k}`)}</p>
            <p className="mt-2 text-base text-slate-700">{t(`funnel.paths.${k}Hook`)}</p>
            <span className="mt-5 inline-flex items-center gap-1.5 text-base font-bold text-orange-700">{t("funnel.paths.go")} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
          </Link>
        );
      })}
    </div>
  );
};

export const PathsSection = () => {
  const { t } = useTranslation();
  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 py-16" data-testid="paths-section">
      <span className="text-xs font-semibold uppercase tracking-wider text-amber-600">{t("funnel.paths.eyebrow")}</span>
      <h2 className="mt-2 mb-8 font-heading text-3xl font-extrabold sm:text-4xl">{t("funnel.paths.title")}</h2>
      <PathCards />
    </section>
  );
};
